exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._20Prv{padding-top:124px;padding-left:20px;padding-right:20px}._2gWJk{margin:0 auto;padding:0 0 40px;max-width:970px}._3xbhc{background-color:#f40000;color:#fff;font-size:14px}", ""]);

// exports
exports.locals = {
	"root": "_20Prv",
	"container": "_2gWJk",
	"alert": "_3xbhc"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/NotLoggedIn/NotLoggedIn.css
// module id = 1127
// module chunks = 0 1 2 3 4